globalThis.appCustomerSpace = globalThis.appCustomerSpace || {};
appCustomerSpace.Controllers = appCustomerSpace.Controllers || {};
appCustomerSpace.Controllers.Statistics = appCustomerSpace.Controllers.Statistics || {};

appCustomerSpace.Controllers.Statistics.SearchKeywordsController = (function(superClass) {

  utils.extend(SearchKeywordsController, superClass);

  function SearchKeywordsController() {
    return SearchKeywordsController.__super__.constructor.apply(this, arguments);
  }

  $.extend(SearchKeywordsController.prototype, {
    init: function() {
      var _this = this;
      _this.events();
      return SearchKeywordsController.__super__.init.apply(this, arguments);
    },
    events: function() {
      var _this = this;
      _this.hasParams = window.location.search;

      if(_this.hasParams) {
        $("#history-container").get(0).scrollIntoView({behavior: 'smooth'});
      }
    }
  });

  return SearchKeywordsController;

})(appCustomerSpace.Controllers.Statistics.MainController);
